/* External Imports */
import {
    AspectRatio, Box, Image,
    Text
} from '@chakra-ui/react';
import ReactPlayer from 'react-player';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/UI/LandingPages/Buttons/SimpleButton';
import StructuredTextContent from '@components/UI/StructuredTextContent';
import SannidhiSectionTitle from './SannidhiSectionTitle';
/* Services */

/**
 * Renders the HowSannidhi content component
 *
 * @param {object} sectionContent - Data for section
 * @returns {ReactElement} HowSannidhiProgram content component
 */

const HowSannidhi = ({ section, region, language }) => {
  const moduledata = section;
  return (
    <>
    {region != 'us' && (
    <Box as="div">
      <Box as="div" width={{ base: '100%' }} m="0 auto">
        <SannidhiSectionTitle titleObj={moduledata[0]} />
      </Box>
      <Box
        as="div"
        width={{ base: '90%', sm: '90%', md: '730px' }}
        m={{ base: '10px auto 15px auto', md: '20px auto 15px auto' }}
        fontSize={{ base: '14px', md: '16px' }}
        lineHeight="27px"
        className="paragraph-text"
      >
        {StructuredTextContent(moduledata[1]?.body)}
      </Box>
      {moduledata[2]?.embedUrl != null &&  (
      <Box
        as="div"
        textAlign="center"
        m="0 auto"
        mt={{ base: '20px', sm: '20px', md: '35px', lg: '35px' }}
        position="relative"
        width={{ base: '95%', sm: '95%', md: '730px', lg: '730px' }}
      >
        <AspectRatio
          borderRadius="20px"
          overflow="hidden"
          width="100%"
          ratio={2}
          height={{ base: '180px', md: '413px' }}
          boxShadow="0px 20px 20px rgba(0, 0, 0, 0.4)"
        >
          <ReactPlayer
            url={moduledata[2]?.embedUrl}
            light={true}
            playing
            controls
            width="100%"
            height="100%"
          />
        </AspectRatio>
        <Box
          as="div"
          pos="absolute"
          left={{ base: '42%', sm: '42%', md: '47%', lg: '47%' }}
          top={{ base: '42%', sm: '42%', md: '46%', lg: '46%' }}
        ></Box>
      </Box>
      )}
      {moduledata[3]?.buttonText != null && (
        <>
          <Box
            as="div"
            display="flex"
            justifyContent="center"
            mt={'30px'}
            mb={{ base: '30px', md: '30px' }}
          >
            <SimpleButton
              style={moduledata[3]}
              region={region}
              lang={language}
              target="_self"
              mb="0"
            />
          </Box>
        </>
      )}
      {moduledata[4]?.titletext !== null && (
      <Box as="div" width={{ base: '100%' }} m="30px auto 0 auto">
        <SannidhiSectionTitle titleObj={moduledata[4]} />
      </Box>
      )}
      <Box
        as="div"
        textAlign="center"
      >
        <Image
          loading="lazy"
          src={moduledata[5]?.image?.url}
          alt={moduledata[5]?.image?.alt}
          title={moduledata[5]?.image?.title}
        />
      </Box>
      {moduledata[3]?.titleText != undefined && (
      <Box as="div" width={{ base: '100%' }} m="0 auto">
        <SannidhiSectionTitle titleObj={moduledata[3]} />
      </Box>
      )}
      <Box
        as="div"
        display="flex"
        flexWrap="wrap"
        margin={{ base: '30px auto 0 auto', md: '40px auto 0 auto' }}
        fontSize="18px"
        gridGap={{ base: '0', md: '54px' }}
        width={{ base: '100%', sm: '100%', md: '730px', lg: '730px' }}
      >
        {moduledata &&
          moduledata[6]?.benefits?.map((data, index) => {
            return (
              <Box
                flex={{
                  base: '100%',
                  sm: '100%',
                  md: '28%',
                }}
                key={index}
                p="0 10px"
                alignItems="center"
                display={{
                  base: 'inline-flex',
                  sm: 'inline-flex',
                  md: 'block',
                  lg: 'block',
                }}
              >
                <Box
                  as="div"
                  width={{ base: '11%', sm: '11%', md: '100%', lg: '100%' }}
                  mr={{ base: '15px', sm: '15px', md: '25px' }}
                  textAlign="center"
                  minH={{ md: '100px', lg: '100px' }}
                >
                  <Image
                    loading="lazy"
                    src={data?.image?.url}
                    alt={data.image.alt}
                    title={data.image.title}
                    height={{
                      base: '44px',
                      sm: '44px',
                      md: 'auto',
                      lg: 'auto',
                    }}
                    m={{ base: '0 0 13px 0' }}
                  />
                </Box>
                <Text
                  fontFamily="FedraSansStd-book, sans-serif"
                  fontSize={{
                    base: '16px',
                  }}
                  m={{ base: '5px 0', sm: '5px 0', md: '0 auto 15px' }}
                  textAlign={{
                    base: 'left',
                    sm: 'left',
                    md: 'center',
                    lg: 'center',
                    xl: 'center',
                  }}
                  p={{ base: '5px 0 16px 0', md: '16px 0' }}
                >
                  {data?.text}
                </Text>
              </Box>
            );
          })}
      </Box>
      
      {moduledata[8]?.body != undefined && (
        <>
          <Box
            as="div"
            width={{ base: '90%', sm: '90%', md: '730px' }}
            m="35px auto 15px auto"
            fontSize="16px"
            lineHeight="27px"
            className="us_text"
          >
            {StructuredTextContent(moduledata[8]?.body)}
          </Box>
        </>
      )}
    </Box>
    )}
    {region === 'us' && (
      <>
      <Box m="0 auto" maxW={{base:'100%', md:'730px'}}>
      <Box as="div" width={{ base: '100%' }} m="0 auto">
        <SannidhiSectionTitle titleObj={moduledata[0]} />
      </Box>
      <Box
        as="div"
        width={{ base: '90%', sm: '90%', md: '730px' }}
        m={{ base: '10px auto 15px auto', md: '20px auto 15px auto' }}
        fontSize={{ base: '14px', md: '16px' }}
        lineHeight="27px"
        className="paragraph-text"
      >
        {StructuredTextContent(moduledata[1]?.body)}
      </Box>
      <Box
        as="p"
        mt={{ base: '40px', sm: '40px', md: '60px' }}
        textAlign="center"
        fontFamily="FedraSansStd-book, sans-serif"
        fontSize={{ base: '20px', sm: '20px', md: '24px', lg: '24px' }}
        lineHeight="36px"
        color="#28231E"
      >
        {moduledata[2]?.titleSubtext}
      </Box>
      {moduledata[2]?.embedUrl != null && (
        <Box
          as="div"
          textAlign="center"
          m="0 auto"
          mt={{ base: '20px', sm: '20px', md: '35px', lg: '35px' }}
          position="relative"
          width={{ base: '95%', sm: '95%', md: '730px', lg: '730px' }}
        >
          <AspectRatio
            borderRadius="20px"
            overflow="hidden"
            width="100%"
            ratio={2}
            height={{ base: '180px', md: '413px' }}
            boxShadow="0px 20px 20px rgba(0, 0, 0, 0.4)"
          >
            <ReactPlayer
              url={moduledata[2]?.embedUrl}
              light={true}
              playing
              controls
              width="100%"
              height="100%"
            />
          </AspectRatio>
        </Box>
      )}
      <Box
        as="div"
        width={{ base: '90%', sm: '90%', md: '730px' }}
        m={{ base: '10px auto 15px auto', md: '30px auto 15px auto' }}
        fontSize={{ base: '14px', md: '16px' }}
        lineHeight="27px"
        className="paragraph-text"
      >
        {StructuredTextContent(moduledata[3]?.body)}
      </Box>
      <Box
        as="div"
        display="flex"
        flexWrap="wrap"
        margin={{ base: '30px auto 0 auto', md: '40px auto 0 auto' }}
        fontSize="18px"
        gridGap={{ base: '0', md: '54px' }}
        width={{ base: '100%', sm: '100%', md: '730px', lg: '730px' }}
      >
        {moduledata &&
          moduledata[4]?.benefits?.map((data, index) => {
            return (
              <Box
                flex={{
                  base: '100%',
                  sm: '100%',
                  md: '28%',
                }}
                key={index}
                p="0 10px"
                alignItems="center"
                display={{
                  base: 'inline-flex',
                  sm: 'inline-flex',
                  md: 'block',
                  lg: 'block',
                }}
              >
                <Box
                  as="div"
                  width={{ base: '11%', sm: '11%', md: '100%', lg: '100%' }}
                  mr={{ base: '15px', sm: '15px', md: '25px' }}
                  textAlign="center"
                  minH={{ md: '100px', lg: '100px' }}
                >
                  <Image
                    loading="lazy"
                    src={data?.image?.url}
                    alt={data.image.alt}
                    title={data.image.title}
                    height={{
                      base: '44px',
                      sm: '44px',
                      md: 'auto',
                      lg: 'auto',
                    }}
                    m={{ base: '0 0 13px 0' }}
                  />
                </Box>
                <Text
                  fontFamily="FedraSansStd-book, sans-serif"
                  fontSize={{
                    base: '16px',
                  }}
                  m={{ base: '5px 0', sm: '5px 0', md: '0 auto 15px' }}
                  textAlign={{
                    base: 'left',
                    sm: 'left',
                    md: 'center',
                    lg: 'center',
                    xl: 'center',
                  }}
                  p={{ base: '5px 0 16px 0', md: '16px 0' }}
                >
                  {data?.text}
                </Text>
              </Box>
            );
          })}
      </Box>
        <Box as="div" width={{ base: '100%' }} m="0 auto">
          <SannidhiSectionTitle titleObj={moduledata[5]} />
        </Box>
        <Box
          as="div"
          width={{ base: '90%', sm: '90%', md: '650px' }}
          m={{ base: '10px auto 15px auto', md: '20px auto 15px auto' }}
          fontSize={{ base: '14px', md: '16px' }}
          lineHeight="27px"
          className="paragraph-text"
        >
          {StructuredTextContent(moduledata[6]?.body)}
        </Box>
        <Box
          as="div"
          width={{ base: '90%', sm: '90%', md: '730px' }}
          m={{ base: '10px auto 15px auto', md: '20px auto 15px auto' }}
          fontSize={{ base: '14px', md: '16px' }}
          lineHeight="27px"
          className="paragraph-text"
        >
          {StructuredTextContent(moduledata[7]?.body)}
        </Box>
        <Box
          as="div"
          width={{ base: '100%' }}
          m={{ base: '30px auto 0 auto', md: '60px auto 0 auto' }}
        >
          <SannidhiSectionTitle titleObj={moduledata[8]} />
        </Box>
      </Box>
      </>
    )}
    
    <style global jsx>
        {`
          .paragraph-text p {
            padding: 10px 0 0 0;
            line-height: 27px;
          }
          .us_text ul {
            padding-left: 28px;
          }
          .us_text ul li {
            line-height: 32px;
          }
          .us_text h3 {
            padding: 15px 0 10px 0;
            font-weight: 600;
          }
          .us_text p {
            margin: 15px 0;
            line-height: 32px;
          }
          .paragraph-text p a,
          .us_text p a {
            text-decoration: underline;
            color: #cf4824;
          }
        `}
      </style>
    </>
  );
};

export default HowSannidhi;
